import $ from 'jquery';
import {initSwiper} from '../libraries/Swiper.mjs';
import {A11y, Pagination, Keyboard, Navigation} from 'swiper';

initIconText();

function initIconText() {
    const $swiperElm = $('.collection-icon-text__slider.swiper');

    if ($swiperElm.length < 1) {
        return;
    }

    let options = {
            spaceBetween: 32,
            modules: [Navigation, Pagination, Keyboard, A11y],
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        };
    
    const swiper = initSwiper($swiperElm, options);
}
